import { Box, Checkbox, IconButton, ListItem, Paper, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import HealingIcon from "@mui/icons-material/Healing";
import MoodBadIcon from "@mui/icons-material/MoodBad";
import React, { FC, memo } from "react";
import cardNameBackground from "../../backgrounds/card_name_background.png";
import { Status } from "../../model/Types";

interface FighterCardHeaderProps {
  name: string;
  rang: string;
  totalCost?: number;
  status?: Status;
  isSelected?: boolean;
  onClick?: () => void;
  onEdit?: () => void;
}

export const FighterCardHeader: FC<FighterCardHeaderProps> = memo(
  ({ name, rang, totalCost, status, isSelected, onClick, onEdit }) => {
    return (
      <ListItem disablePadding sx={{ mb: "10px" }}>
        <Paper
          sx={{
            width: "100%",
            backgroundColor: "transparent",
            backgroundImage: `url('${cardNameBackground}')`,
            backgroundPosition: "center",
            backgroundSize: "120% 120%",
            pt: "8px",
          }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              letterSpacing: "1px",
            }}>
            <Typography
              component={"span"}
              variant="h6"
              color="secondary"
              sx={{
                ml: "10px",
                '@media print': { color: "black" },
              }}>
              {name}
            </Typography>
            <Typography
              component={"span"}
              variant="body1"
              color="secondary"
              sx={{ ml: "10px", textTransform: "capitalize", '@media print': { color: "black" } }}>
              {rang}
            </Typography>
            {status === Status.ON_RECOVERY && <RecoveryIndicator />}
            {status === Status.DEAD && <DeadIndicator />}
            {onEdit && (
              <IconButton
                size="small"
                onClick={onEdit}
                sx={{ ml: 0.5, color: "rgba(240, 244, 228, 0.7)" }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            )}
            {isSelected !== undefined && onClick !== undefined ? (
              <Checkbox
                sx={{ color: "rgba(240, 244, 228, 0.7)" }}
                color="secondary"
                checked={isSelected}
                onChange={onClick}
                inputProps={{ "aria-label": "select" }}
              />
            ) : (
              <></>
            )}
            {totalCost !== undefined ? (
              <CreditsCostContainer cost={totalCost} />
            ) : (
              <></>
            )}
          </Box>
        </Paper>
      </ListItem>
    );
  }
);

function RecoveryIndicator() {
  return (
    <Box
      sx={{
        width: "52px",
        height: "52px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}>
      <HealingIcon sx={{ color: "rgba(66, 165, 245, 0.75)", fontSize: "28px" }} />
       <Typography sx={{ color: "rgba(66, 165, 245, 0.75)", fontSize: "0.5rem", fontWeight: 700, lineHeight: 1 }}>
        RECOVERY
      </Typography>
    </Box>
  );
}

function DeadIndicator() {
  return (
    <Box
      sx={{
        width: "52px",
        height: "52px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}>
      <MoodBadIcon sx={{ color: "rgba(211, 47, 47, 0.85)", fontSize: "22px" }} />
      <Typography sx={{ color: "red", fontSize: "0.5rem", fontWeight: 700, lineHeight: 1 }}>
        DEAD
      </Typography>
    </Box>
  );
}

interface CreditsCostContainerProps {
  cost: number;
}

function CreditsCostContainer({ cost }: CreditsCostContainerProps) {
  return (
    <Box
      sx={{
        position: "absolute",
        right: "-20px",
        top: "-10px",
        backgroundColor: "#d6d6d6",
        borderRadius: "50%",
        border: "5px solid #302429",
        textAlign: "center",
        padding: "7px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        aspectRatio: "1/1",
      }}>
      <Typography
        sx={{ fontWeight: "600", lineHeight: "0.7", mb: "6px" }}
        variant="h6">
        {cost}
      </Typography>
      <Typography
        sx={{ fontSize: "0.6rem", lineHeight: "0.8" }}
        variant="caption">
        Credits
      </Typography>
    </Box>
  );
}
